/**
 * This will replace the element with a template
 * @example ng-banner-choice="/views/footer.html" data-provider="" data-position="top"
 * ‘@’ – Text binding / one-way binding
 * ‘=’ – Direct model binding / two-way binding
 */

const ngBannerChoice = [ function () {
    return {
        replace: true,
        scope: {
            provider: '@provider',
            position: '@position',
        },
        /**
         * @param $item
         * @param $params {{ ngBannerChoice }}
         */
        templateUrl: function( $item, $params ) {
            return $params.ngBannerChoice;
        }
    }
}];

export default ngBannerChoice;

